const amountOfCreditWalletTransactionsOnPage = 20;

export default amountOfCreditWalletTransactionsOnPage;
